import React from 'react'

const Tracks = () => {
  return (
    <div>Tracks</div>
  )
}

export default Tracks